import React from "react";

function Contact() {
    return (
        <div className="contact">
            <div className="container">
                <div className="row align-items-center my-5">
                    <div className="col-lg-7">
                        <img className="img-fluid rounded mb-4 mb-lg-0" src="https://i.picsum.photos/id/1/900/400.jpg?hmac=6LDhMyRAm4UY8Ac2oY8VRmYQkFzLh8958iF2mhEQH1Y" alt="name"
                        />
                    </div>
                    <div className="col-lg-5">
                        <h1 className="font-weight-light">Contact</h1>
                        <p>
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nisi molestias numquam eveniet ea vel facilis sed, blanditiis qui sequi, a unde, obcaecati velit enim quis.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact